import { SvgIconComponent } from '@mui/icons-material';
import { Box } from '@mui/material';

const getIconStyles = (disabled?: boolean) => ({
  backgroundColor: disabled ? 'grey.200' : 'primary.main',
  borderRadius: '50%',
  width: { xs: '1.75rem', sm: '2.5rem' },
  height: { xs: '1.75rem', sm: '2.5rem' },
  display: 'grid',
  placeItems: 'center',
});

const StyledIcon = ({ Icon, disabled }: { Icon: SvgIconComponent; disabled?: boolean }) => {
  return (
    <Box sx={getIconStyles(disabled)}>
      <Icon sx={{ fill: '#fff', fontSize: { xs: '1rem', sm: '1.5rem' } }} />
    </Box>
  );
};

export default StyledIcon;
